export default {
  brokerInformation: {
    brokerName: '',
    brokerEmail: '',
    brokerPhone: '',
    brokerAddress: '',
    brokerCountry: '',
    brokerCompany: '',
    brokerRole: '',
  },
  submittedBrokerInformation: false,
  availableBrokers: [],
}